/**
 * TODO: 乐象亲子
 * 排序
 * 位置
 * 筛选
 *
 */
// remove array;
//
function removeArrItem({ category = [], sign }) {
  const names = Array.isArray(sign) ? sign : [sign];
  const resultMap = new Map();
  names.forEach((itemName) => {
    category.some((item, i) => {
      if (item.name === itemName) {
        category.splice(i, 1);
        resultMap.set(item.name, item);
      }
    });
  });

  return resultMap;
}
// 排序
const SortList = [
  {
    id: 1,
    name: "综合",
    shotName: "综合",
  },
  {
    id: 7,
    name: "距离优先",
    shotName: "距离优先",
  },
  {
    id: 4,
    name: "价格优先",
    shotName: "价格优先",
  },
  // {
  //   id: 4000,
  //   sortType: 1, // 高倒序
  //   name: "高价优先",
  //   shotName: "高价",
  // },
];

const FilterList = [
  {
    name: "价格筛选",
    type: "input",
  },
];

const lexiangFilter = (category) => {
  const sign = ["区域", "附近", '价格'];
  const filerValues = removeArrItem({ category, sign });
  const RegionData = filerValues.get("区域") || {}
  const fields = [
    // 排序
    {
      name: "排序",
      list: SortList,
    },
    // 位置
    {
      name: RegionData.name,
      component: "radioChoice",
      list:  [
        {
          "id": null,
          "name": "全部",
          "text": "全部",
          "areaDtos": [
            {
              "id": null,
              "cityId": null,
              "name": null,
              "text": "不限"
            },
          ]
        },
        ...RegionData.list
      ]
    },
    // 筛选
    {
      name: "价格",
      component: "multiChoice",
      list: [
        ...FilterList,
      ],
    },
  ];
  fields.forEach((field) => category.push(field));
  return category;
};

export { lexiangFilter };
